import { createContext, useContext, useReducer, Dispatch } from "react";
import { v4 } from "uuid";
import Notification from "./Notification";
import "./Notification.css";
import ReactDOM from "react-dom";

type NotificationAction =
  | { type: "ADD_NOTIFICATION"; payload: any }
  | { type: "REMOVE_NOTIFICATION"; id: string };

const NotificationContext = createContext<
  Dispatch<NotificationAction> | undefined
>(undefined);
const notificationRoot = document.getElementById("notification-root");

const NotificationProvider = (props: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(
    (state: any[], action: NotificationAction) => {
      switch (action.type) {
        case "ADD_NOTIFICATION":
          return [...state, { ...action.payload }];
        case "REMOVE_NOTIFICATION":
          return state.filter((el: any) => el.id !== action.id);
        default:
          return state;
      }
    },
    []
  );

  return ReactDOM.createPortal(
    <NotificationContext.Provider value={dispatch}>
      {state.length > 0 && (
        <div className={"notification-wrapper"}>
          {state.map((note: any) => {
            return <Notification dispatch={dispatch} key={note.id} {...note} />;
          })}
        </div>
      )}
      {props.children}
    </NotificationContext.Provider>,
    notificationRoot as Element
  );
};

export const useNotification = () => {
  const dispatch = useContext(NotificationContext);

  return (props: any) => {
    if (dispatch) {
      dispatch({
        type: "ADD_NOTIFICATION",
        payload: {
          id: v4(),
          ...props,
        },
      });
    }
  };
};

export default NotificationProvider;
